import React from "react"
import { Breadcrumb } from "react-bootstrap"
import { browserHistory } from "react-router"

export default function CustomBreadCrumb({ data, activeText }) {

  return (
    <Breadcrumb>
      <Breadcrumb.Item href="#" onClick={() => browserHistory.push('/') }>Home</Breadcrumb.Item>
      { data.map((item, index) =>
        <Breadcrumb.Item key={ index } href="#" onClick={() => browserHistory.push(item.url) }>{ item.title }</Breadcrumb.Item>)}
      <Breadcrumb.Item active>{ activeText }</Breadcrumb.Item>
    </Breadcrumb>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/CustomBreadCrumb.js